// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import HomePage from './components/HomePage';
import AboutPage from './components/AboutPage';
import RiskAssessmentPage from './components/RiskAssessmentPage';
import SourceCodeReviewPage from './components/SourceCodeReviewPage';
import ThirdPartyRiskPage from './components/ThirdPartyRiskPage';
import VAPTServicesPage from './components/VAPTServicesPage';
import CloudSecurityPage from './components/CloudSecurityPage';
import ContactUsPage from './components/ContactUsPage';
import CompliancePage from './components/CompliancePage';
import CyberServicesPage from './components/CyberServicesPage';
import AIServicesPage from './components/AIServicesPage';
import AISpecificServices from './components/AISpecificServices';
import ChatbotWidget from './components/ChatBotWidget';
import WebServicesPage from './components/WebServicesPage';
import WebSpecificService from './components/WebSpecificServices';
import Footer from './components/Footer';
import Awards from './components/Awards'
import './App.css';


// Placeholder components for other pages
const ServicesPage = () => (
  <div style={{ padding: '100px 20px', textAlign: 'center', minHeight: '60vh' }}>
    <h1>Our Services</h1>
    <p>Services page content will be implemented here.</p>
  </div>
);


const AwardsPage = () => (
  <div style={{ padding: '100px 20px', textAlign: 'center', minHeight: '60vh' }}>
    <h1>Awards & Certification</h1>
    <p>Awards page content will be implemented here.</p>
  </div>
);

const ContactPage = () => <ContactUsPage />;

// Service specific pages
const RiskAssessmentPage_Route = () => <RiskAssessmentPage />;



const ThirdPartyRiskPage_Route = () => <ThirdPartyRiskPage />;

const VAPTPage_Route = () => <VAPTServicesPage />;

const CloudSecurityPage_Route = () => <CloudSecurityPage />;

const NetworkSecurityPage = () => (
  <div style={{ padding: '100px 20px', textAlign: 'center', minHeight: '60vh' }}>
    <h1>Network Security Services</h1>
    <p>Network Security page content will be implemented here.</p>
  </div>
);

const CyberDefensePage = () => (
  <div style={{ padding: '100px 20px', textAlign: 'center', minHeight: '60vh' }}>
    <h1>Cyber Defense & Incident Response</h1>
    <p>Cyber Defense page content will be implemented here.</p>
  </div>
);



// Compliance specific pages
const ISO27001Page = () => (
  <div style={{ padding: '100px 20px', textAlign: 'center', minHeight: '60vh' }}>
    <h1>ISO 27001 Certification Assistance</h1>
    <p>ISO 27001 page content will be implemented here.</p>
  </div>
);

const SOC2Page = () => (
  <div style={{ padding: '100px 20px', textAlign: 'center', minHeight: '60vh' }}>
    <h1>SOC 2 Compliance Support</h1>
    <p>SOC 2 page content will be implemented here.</p>
  </div>
);

const NISTPage = () => (
  <div style={{ padding: '100px 20px', textAlign: 'center', minHeight: '60vh' }}>
    <h1>NIST Cybersecurity Framework Compliance</h1>
    <p>NIST page content will be implemented here.</p>
  </div>
);

const CISPage = () => (
  <div style={{ padding: '100px 20px', textAlign: 'center', minHeight: '60vh' }}>
    <h1>CIS Controls</h1>
    <p>CIS Controls page content will be implemented here.</p>
  </div>
);

const HIPAAPage = () => (
  <div style={{ padding: '100px 20px', textAlign: 'center', minHeight: '60vh' }}>
    <h1>HIPAA Compliance Services</h1>
    <p>HIPAA page content will be implemented here.</p>
  </div>
);

const HITECHPage = () => (
  <div style={{ padding: '100px 20px', textAlign: 'center', minHeight: '60vh' }}>
    <h1>HITECH Compliance</h1>
    <p>HITECH page content will be implemented here.</p>
  </div>
);

const GDPRPage = () => (
  <div style={{ padding: '100px 20px', textAlign: 'center', minHeight: '60vh' }}>
    <h1>GDPR Compliance Services</h1>
    <p>GDPR page content will be implemented here.</p>
  </div>
);

const PCIDSSPage = () => (
  <div style={{ padding: '100px 20px', textAlign: 'center', minHeight: '60vh' }}>
    <h1>PCI-DSS Compliance Services</h1>
    <p>PCI-DSS page content will be implemented here.</p>
  </div>
);

const FISMAPage = () => (
  <div style={{ padding: '100px 20px', textAlign: 'center', minHeight: '60vh' }}>
    <h1>FISMA Compliance</h1>
    <p>FISMA page content will be implemented here.</p>
  </div>
);

const CMMCPage = () => (
  <div style={{ padding: '100px 20px', textAlign: 'center', minHeight: '60vh' }}>
    <h1>CMMC Support</h1>
    <p>CMMC page content will be implemented here.</p>
  </div>
);

const FedRAMPPage = () => (
  <div style={{ padding: '100px 20px', textAlign: 'center', minHeight: '60vh' }}>
    <h1>FedRAMP Compliance</h1>
    <p>FedRAMP page content will be implemented here.</p>
  </div>
);

const ITARPage = () => (
  <div style={{ padding: '100px 20px', textAlign: 'center', minHeight: '60vh' }}>
    <h1>ITAR Compliance</h1>
    <p>ITAR page content will be implemented here.</p>
  </div>
);

const ISO42001Page = () => (
  <div style={{ padding: '100px 20px', textAlign: 'center', minHeight: '60vh' }}>
    <h1>ISO/IEC 42001 (AI Management System)</h1>
    <p>ISO 42001 page content will be implemented here.</p>
  </div>
);

const COBITPage = () => (
  <div style={{ padding: '100px 20px', textAlign: 'center', minHeight: '60vh' }}>
    <h1>COBIT (IT Governance Framework)</h1>
    <p>COBIT page content will be implemented here.</p>
  </div>
);

function App() {
  
  return (
    <Router>
      <div className="App">
        <Header />
        <main>
          <Routes>
            {/* Main Pages */}
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/compliance" element={<CompliancePage />} />
            <Route path="/awards" element={<Awards />} />
            <Route path="/contact" element={<ContactPage />} />

            {/* Service Pages */}
            <Route path="/services/risk-assessment" element={<RiskAssessmentPage_Route />} />
            <Route path="/services/source-code-review" element={<SourceCodeReviewPage />} />
            <Route path="/services/third-party-risk" element={<ThirdPartyRiskPage_Route />} />
            <Route path="/services/vapt" element={<VAPTPage_Route />} />
            <Route path="/services/cloud-security" element={<CloudSecurityPage_Route />} />
            <Route path="/services/network-security" element={<NetworkSecurityPage />} />
            <Route path="/services/cyber-defense" element={<CyberDefensePage />} />
          

             <Route path="/services/cyber-services" element={<CyberServicesPage />} />
             <Route path="/ai-services" element={<AIServicesPage />} />
            <Route path="/ai-services/:serviceType" element={<AISpecificServices />} />
            <Route path="/web-services" element={<WebServicesPage />} />
<Route path="/web-services/:serviceType" element={<WebSpecificService />} />

            {/* Compliance Pages - Dynamic Routes */}
            <Route path="/compliance/iso-27001" element={<CompliancePage />} />
            <Route path="/compliance/soc2" element={<CompliancePage />} />
            <Route path="/compliance/nist" element={<CompliancePage />} />
            <Route path="/compliance/cis" element={<CompliancePage />} />
            <Route path="/compliance/hipaa" element={<CompliancePage />} />
            <Route path="/compliance/hitech" element={<CompliancePage />} />
            <Route path="/compliance/gdpr" element={<CompliancePage />} />
            <Route path="/compliance/pci-dss" element={<CompliancePage />} />
            <Route path="/compliance/fisma" element={<CompliancePage />} />
            <Route path="/compliance/cmmc" element={<CompliancePage />} />
            <Route path="/compliance/fedramp" element={<CompliancePage />} />
            <Route path="/compliance/itar" element={<CompliancePage />} />
            <Route path="/compliance/iso-42001" element={<CompliancePage />} />
            <Route path="/compliance/cobit" element={<CompliancePage />} />

            {/* AI Services Routes */}
            {/*
             <Route path="/ai-services" element={<AIServicesPage />} />
            <Route path="/ai-services/predictive-analytics" element={<AISpecificServices />} />
            <Route path="/ai-services/chatbots-virtual-assistants" element={<AISpecificServices />} />
            <Route path="/ai-services/personalized-recommendations" element={<AISpecificServices />} />
            <Route path="/ai-services/sentiment-analysis" element={<AISpecificServices />} />
            <Route path="/ai-services/document-summarization" element={<AISpecificServices />} />
            <Route path="/ai-services/speech-text-conversion" element={<AISpecificServices />} />
            <Route path="/ai-services/demand-forecasting" element={<AISpecificServices />} />
            <Route path="/ai-services/vision-ai" element={<AISpecificServices />} />
  <Route path="/ai-services/content-creation" element={<AISpecificServices />} />
  <Route path="/ai-services/natural-language-generation" element={<AISpecificServices />} />
  <Route path="/ai-services/customer-behavior-modeling" element={<AISpecificServices />} />
  <Route path="/ai-services/fraud-detection" element={<AISpecificServices />} />
  <Route path="/ai-services/adaptive-learning" element={<AISpecificServices />} />
  <Route path="/ai-services/multi-lingual-translation" element={<AISpecificServices />} />
  <Route path="/ai-services/legal-document-analysis" element={<AISpecificServices />} />
  <Route path="/ai-services/trend-pattern-recognition" element={<AISpecificServices />} />
  */}        
  </Routes>
        </main>
        <ChatbotWidget />
        <Footer />
         
      </div>
    </Router>
  );
}

export default App;